import { Component } from "@angular/core";

@Component({
    selector: "vds-breadcrumb-divider",
    templateUrl: "./breadcrumb-divider.component.html",
    styleUrl: "./breadcrumb-divider.component.css",
    standalone: true
})
export class VdsBreadcrumbDividerComponent {}
